import { render } from "./AnnotationLabelFilter.vue?vue&type=template&id=3ea8b77e&scoped=true"
import script from "./AnnotationLabelFilter.vue?vue&type=script&lang=js"
export * from "./AnnotationLabelFilter.vue?vue&type=script&lang=js"

import "./AnnotationLabelFilter.vue?vue&type=style&index=0&id=3ea8b77e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea8b77e"]])

export default __exports__